import React, { useState } from 'react'
import ContactForm from './ContactForm';

const ServiceCard = ({ data }) => {
    const [active, setActive] = useState(false);
    const onClick = () => {
        // to do
    }
    return (
        <div>
            <div className={`card service-card ${active ? "active" : ""}`} style={{ "width": "18rem" }} onClick={onClick}
                onMouseEnter={() => setActive(true)}
                onMouseLeave={() => setActive(false)}>
                <img src={data.image} className="card-img-bottom" alt={data.title} />
                <h5 className="card-title mt-2">{data.title}</h5>
                <div className="card-body">
                    <p className="card-text">{data.description}</p>
                    <button type="button" className="btn btn-outline-light " data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Contact US
                    </button>
                </div>
            </div>

            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title text-primary fs-5" id="exampleModalLabel">Send Us a Message</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <p className="text-muted mx-4 mb-1">
                            Have questions about our products or services? Need a custom PC quote?
                            Fill out the form below and our tech experts will get back to you within 24 hours.
                        </p>
                        <div className="modal-body">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceCard